import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import { BackResponse, BackResponseFailure } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}owners/hasOpenFile`;

export interface GetOwnersWithOpenFileQueryArgs {
  ownerIds: string[];
}

export async function getOwnersWithOpenFileQuery({
  ownerIds,
}: GetOwnersWithOpenFileQueryArgs): Promise<
  BackResponse<string[]> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<string[]>>(
      buildUrl(ENDPOINT, { ownerIds }, { arrayFormat: 'repeat' }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
